var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$can('manage-collective-gateways', 'ipg-gateway'))?_c('main-content',{attrs:{"with_go_back_bar":""}},[_c('collective-gateway-filter',{attrs:{"action":_vm.filterAction}}),_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }